import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const MerchantLeaderboard = ({ merchants }) => {
  const getRankBadgeColor = (rank) => {
    if (rank === 1) return 'bg-accent text-accent-foreground';
    if (rank === 2) return 'bg-muted text-foreground';
    if (rank === 3) return 'bg-muted/70 text-foreground';
    return 'bg-muted/50 text-muted-foreground';
  };

  return (
    <div className="card h-full">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-lg font-semibold text-foreground mb-1">
            Top Merchants
          </h3>
          <p className="caption text-muted-foreground">
            By fee contribution
          </p>
        </div>
        <Icon name="Trophy" size={20} className="text-accent" />
      </div>
      <div className="space-y-4">
        {merchants?.map((merchant) => (
          <div 
            key={merchant?.id}
            className="flex items-center gap-3 p-3 rounded-lg hover:bg-muted/30 transition-smooth cursor-pointer"
          >
            <div className={`w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 text-xs font-bold ${getRankBadgeColor(merchant?.rank)}`}>
              {merchant?.rank}
            </div>

            <div className="w-10 h-10 rounded-lg overflow-hidden flex-shrink-0 bg-muted">
              <Image 
                src={merchant?.logo}
                alt={merchant?.logoAlt}
                className="w-full h-full object-cover"
              />
            </div>

            <div className="flex-1 min-w-0">
              <p className="text-sm font-semibold text-foreground truncate">
                {merchant?.name}
              </p>
              <p className="caption text-muted-foreground">
                {merchant?.transactions?.toLocaleString()} txns
              </p>
            </div>

            <div className="text-right flex-shrink-0">
              <p className="text-sm font-bold text-foreground font-data">
                ${merchant?.fees?.toLocaleString()}
              </p>
              <div className="flex items-center justify-end gap-1">
                <Icon 
                  name={merchant?.growth >= 0 ? 'TrendingUp' : 'TrendingDown'} 
                  size={12} 
                  className={merchant?.growth >= 0 ? 'text-success' : 'text-error'}
                />
                <span className={`caption ${merchant?.growth >= 0 ? 'text-success' : 'text-error'}`}>
                  {merchant?.growth}%
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
      <button className="w-full mt-4 py-2 text-sm font-medium text-primary hover:text-primary/80 transition-smooth">
        View All Merchants
      </button>
    </div>
  );
};

export default MerchantLeaderboard;